/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/databricks" */ '@atlassian/logo-third-party/databricks'
		).then((m) => m.DatabricksIcon),
	{ moduleId: '@atlassian/logo-third-party/databricks' },
);

const LazyDatabricksIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-databricks" */ './utils').then((m) => m.DatabricksIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/databricks/icon' },
);

const LazyDatabricksSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-databricks-search-result" */ './utils').then(
			(m) => m.DatabricksSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/databricks/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const DatabricksIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyDatabricksIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const DatabricksSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyDatabricksSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
